import { isValidUrl } from '@omnea-app/packages/universal/general/isValidUrl'

export const getURLFromString = (website: string): URL | null => {
  if (!isValidUrl(website)) {
    return null
  }
  try {
    const lowercased = website.toLowerCase()
    const hasProtocol = lowercased.startsWith('http://') || lowercased.startsWith('https://')
    return new URL(`${hasProtocol ? '' : 'https://'}${website}`)
  } catch (error) {
    console.info(error)
    return null
  }
}
